import { code } from "@spscommerce/utils";
import { DSReactExamples } from "@spscommerce/ds-shared";

export const SpsToggleExamples: DSReactExamples = {
    small: {
        label: "Small",
        description: "info about small toggle buttons",
        examples: {
            a_small: {
                react: code`
                    function DemoComponent() {
                        const { formValue, formMeta, updateForm } = useSpsForm({
                            toggle: false
                        });

                        return <SpsToggle formMeta={formMeta.fields.toggle}
                            active={formValue.toggle}
                        />;
                    }
                `
            },
            b_changeHandler: {
                description: "With UseState",
                react: code`
                    function DemoComponent() {
                        function changeHandler() {
                            setActive(!checked);
                        }
                        const [active, setActive] = React.useState();
                        return (
                            <SpsToggle active={active} onChange={changeHandler}/>
                        )
                    }
                `
            }
        }
    },
    b_large: {
        label: "Large",
        description: "info about large toggle buttons",
        examples: {
            a_large: {
                react: code`
                    function DemoComponent() {
                        const { formValue, formMeta, updateForm } = useSpsForm({
                            toggle: true
                        });

                        return <SpsToggle large formMeta={formMeta.fields.toggle}
                            active={formValue.toggle}
                        />;
                    }
                `
            }
        }
    },
    c_statusLabel: {
        label: "Status Label",
        description: "toggles with status labels",
        examples: {
            label: {
                react: code`
                    function DemoComponent() {
                        function changeHandler() {
                            setActive(!active);
                        }
                        const [active, setActive] = React.useState();
                        return (
                            <SpsToggle
                                activeLabel="ACTIVE"
                                activeDescription="active description"
                                active={active}
                                onChange={changeHandler}
                                inactiveLabel="INACTIVE"
                                inactiveDescription="inactive description"
                            />
                        )
                    }
                `
            }
        }
    },
    d_disabled: {
        label: "Disabled",
        description: "info about disabled toggles",
        examples: {
            disabled: {
                react: code`
                    function DemoComponent() {
                        const { formValue, formMeta, updateForm } = useSpsForm({
                            toggle: false
                        });

                        return <SpsToggle formMeta={formMeta.fields.toggle}
                            active={formValue.toggle}
                            disabled
                        />;
                    }
                `
            }
        }
    }
};
